export const SAVE_AFTER_STOP_DELAY = 2000;
export const SAVE_INDICATOR_DELAY = 1500;
